<!-- <form [formGroup]="formGroup"> -->
<div class="checkboxes-modal-empty">
  <div mat-dialog-title>
    <h2>{{"restaurant.Add Ingredients" | translate}}</h2>
    <button mat-icon-button class="close" (click)="openConfirmDialog()">
      <mat-icon class="pop-close">close</mat-icon>
    </button>
  </div>

  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>
  <ng-container *ngIf='!dataLoading'>
    <div class="modal-subhead">
      <div class="row">
        <div class="col-7 d-block m-auto">

            <div class="form-group">
              <div class="input-group search-control">
                <div class="input-group-prepend">
                  <button class="input-group-text" type="button" (click)="makeFilter()">
                    <img src="./assets/images/icons/search.svg" alt="">
                  </button>
                </div>
                <input type="text" maxlength="20"
                  class="form-control font-14"
                  [(ngModel)]="searchText" [pattern]="noSpecialTxt"
                  [placeholder]="'forms.Search for ingredients' | translate"
                  (keyup.enter)="makeFilter()">
              </div>
            </div>
        </div>
        <div class="col-1">
          <mat-icon matBadge="." matBadgeColor="warn" *ngIf="categorySelected"></mat-icon>
          <img class="image-badge" src="./assets/images/icons/filter-outline.svg">
        </div>
        <div class="col-4 pl-0 w-auto">
          <mat-form-field appearance="fill">
            <mat-label class="font-14">{{'forms.Filter by Category' | translate}}</mat-label>
            <mat-select [(ngModel)]="categorySelected"
              (selectionChange)="makeFilter()">
              <mat-option>{{'forms.None' | translate}}</mat-option>
              <mat-option [value]="category.id" *ngFor="let category of categoryList" class="font-16">{{category.name}} <span class="badge badge-pill badge-light mt-2" *ngIf="category.sourceType">{{'content5.' + category.sourceType | translate}}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <mat-dialog-content
      class="pt-1 checkboxes-modal"
      *ngIf="dataList?.length else dataEmpty"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="pageCount"
      (scrolled)="getNextPage()">
      <div class="mat-dialog-body">
        <ng-container *ngFor="let item of dataList; index as i">
          <div>
            <mat-checkbox class="p-2 d-block"
              [class.border-0]="i == dataList.length - 1"
              [(ngModel)]="item.isSelected"
              [disabled]="!item.canSelect"
              (change)="selected($event, item)">
              <div class="name-with-image squared ml-3">
                <div class="image-circle">
                  <img [src]="item.icon" alt="">
                </div>
                <div class="name">
                  <h5 class="font-16">{{item.name}}</h5>
                </div>
              </div>
            </mat-checkbox>
          </div>
        </ng-container>
      </div>
    </mat-dialog-content>
    <!-- <mat-dialog-content
      class="pt-1 checkboxes-modal"
      *ngIf="hasRecordsData() else dataEmpty">
      <div class="mat-dialog-body">

        <ng-container *ngFor="let item of recordsData?.pageData">
          <div [hidden]="(searchText && hideOption(item)) || hideByCategory(item)">
            <mat-checkbox class="p-2"
              [(ngModel)]="item.isSelected"
              hidden [class.d-block]="item.canSelect"
              (change)="selected($event, item)">
              <div class="name-with-image squared ml-3">
                <div class="image-circle">
                  <img [src]="item.icon" alt="">
                </div>
                <div class="name">
                  <h5 class="font-16">{{item.name}}</h5>
                </div>
              </div>
            </mat-checkbox>
          </div>

        </ng-container>
      </div>
    </mat-dialog-content> -->
    <mat-dialog-actions>
      <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>


      <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="dataLoading"
        [class.loading]="dataLoading">
        {{"forms.Submit" | translate}}
      </button>

    </mat-dialog-actions>

    <ng-template #dataEmpty>
      <empty-state [title]='"general.No Data Found" | translate'></empty-state>
    </ng-template>
  </ng-container>
</div>
<!-- </form> -->
